export const meta = {
    "isTree": true,
    "dataType": [
        {
            "name": "GeoJSON",
            "suffix": ".json"
        },
        {
            "name": "TopoJSON",
            "suffix": ".topo.json"
        }
    ],
    "files": [
        {
            "name": "中华人民共和国",
            "filename": "100000",
            "children": [
                {
                    "name": "北京市",
                    "filename": "110000"
                },
                {
                    "name": "天津市",
                    "filename": "120000"
                },
                {
                    "name": "河北省",
                    "filename": "130000",
                    "children": [
                        {
                            "name": "石家庄市",
                            "filename": "130000/130100"
                        },
                        {
                            "name": "唐山市",
                            "filename": "130000/130200"
                        },
                        {
                            "name": "秦皇岛市",
                            "filename": "130000/130300"
                        },
                        {
                            "name": "邯郸市",
                            "filename": "130000/130400"
                        },
                        {
                            "name": "邢台市",
                            "filename": "130000/130500"
                        },
                        {
                            "name": "保定市",
                            "filename": "130000/130600"
                        },
                        {
                            "name": "张家口市",
                            "filename": "130000/130700"
                        },
                        {
                            "name": "承德市",
                            "filename": "130000/130800"
                        },
                        {
                            "name": "沧州市",
                            "filename": "130000/130900"
                        },
                        {
                            "name": "廊坊市",
                            "filename": "130000/131000"
                        },
                        {
                            "name": "衡水市",
                            "filename": "130000/131100"
                        },
                        {
                            "name": "雄安新区",
                            "filename": "130000/133100"
                        }
                    ]
                },
                {
                    "name": "山西省",
                    "filename": "140000",
                    "children": [
                        {
                            "name": "太原市",
                            "filename": "140000/140100"
                        },
                        {
                            "name": "大同市",
                            "filename": "140000/140200"
                        },
                        {
                            "name": "阳泉市",
                            "filename": "140000/140300"
                        },
                        {
                            "name": "长治市",
                            "filename": "140000/140400"
                        },
                        {
                            "name": "晋城市",
                            "filename": "140000/140500"
                        },
                        {
                            "name": "朔州市",
                            "filename": "140000/140600"
                        },
                        {
                            "name": "晋中市",
                            "filename": "140000/140700"
                        },
                        {
                            "name": "运城市",
                            "filename": "140000/140800"
                        },
                        {
                            "name": "忻州市",
                            "filename": "140000/140900"
                        },
                        {
                            "name": "临汾市",
                            "filename": "140000/141000"
                        },
                        {
                            "name": "吕梁市",
                            "filename": "140000/141100"
                        }
                    ]
                },
                {
                    "name": "内蒙古自治区",
                    "filename": "150000",
                    "children": [
                        {
                            "name": "呼和浩特市",
                            "filename": "150000/150100"
                        },
                        {
                            "name": "包头市",
                            "filename": "150000/150200"
                        },
                        {
                            "name": "乌海市",
                            "filename": "150000/150300"
                        },
                        {
                            "name": "赤峰市",
                            "filename": "150000/150400"
                        },
                        {
                            "name": "通辽市",
                            "filename": "150000/150500"
                        },
                        {
                            "name": "鄂尔多斯市",
                            "filename": "150000/150600"
                        },
                        {
                            "name": "呼伦贝尔市",
                            "filename": "150000/150700"
                        },
                        {
                            "name": "巴彦淖尔市",
                            "filename": "150000/150800"
                        },
                        {
                            "name": "乌兰察布市",
                            "filename": "150000/150900"
                        },
                        {
                            "name": "兴安盟",
                            "filename": "150000/152200"
                        },
                        {
                            "name": "锡林郭勒盟",
                            "filename": "150000/152500"
                        },
                        {
                            "name": "阿拉善盟",
                            "filename": "150000/152900"
                        }
                    ]
                },
                {
                    "name": "辽宁省",
                    "filename": "210000",
                    "children": [
                        {
                            "name": "沈阳市",
                            "filename": "210000/210100"
                        },
                        {
                            "name": "大连市",
                            "filename": "210000/210200"
                        },
                        {
                            "name": "鞍山市",
                            "filename": "210000/210300"
                        },
                        {
                            "name": "抚顺市",
                            "filename": "210000/210400"
                        },
                        {
                            "name": "本溪市",
                            "filename": "210000/210500"
                        },
                        {
                            "name": "丹东市",
                            "filename": "210000/210600"
                        },
                        {
                            "name": "锦州市",
                            "filename": "210000/210700"
                        },
                        {
                            "name": "营口市",
                            "filename": "210000/210800"
                        },
                        {
                            "name": "阜新市",
                            "filename": "210000/210900"
                        },
                        {
                            "name": "辽阳市",
                            "filename": "210000/211000"
                        },
                        {
                            "name": "盘锦市",
                            "filename": "210000/211100"
                        },
                        {
                            "name": "铁岭市",
                            "filename": "210000/211200"
                        },
                        {
                            "name": "朝阳市",
                            "filename": "210000/211300"
                        },
                        {
                            "name": "葫芦岛市",
                            "filename": "210000/211400"
                        }
                    ]
                },
                {
                    "name": "吉林省",
                    "filename": "220000",
                    "children": [
                        {
                            "name": "长春市",
                            "filename": "220000/220100"
                        },
                        {
                            "name": "吉林市",
                            "filename": "220000/220200"
                        },
                        {
                            "name": "四平市",
                            "filename": "220000/220300"
                        },
                        {
                            "name": "辽源市",
                            "filename": "220000/220400"
                        },
                        {
                            "name": "通化市",
                            "filename": "220000/220500"
                        },
                        {
                            "name": "白山市",
                            "filename": "220000/220600"
                        },
                        {
                            "name": "松原市",
                            "filename": "220000/220700"
                        },
                        {
                            "name": "白城市",
                            "filename": "220000/220800"
                        },
                        {
                            "name": "延边朝鲜族自治州",
                            "filename": "220000/222400"
                        }
                    ]
                },
                {
                    "name": "黑龙江省",
                    "filename": "230000",
                    "children": [
                        {
                            "name": "哈尔滨市",
                            "filename": "230000/230100"
                        },
                        {
                            "name": "齐齐哈尔市",
                            "filename": "230000/230200"
                        },
                        {
                            "name": "鸡西市",
                            "filename": "230000/230300"
                        },
                        {
                            "name": "鹤岗市",
                            "filename": "230000/230400"
                        },
                        {
                            "name": "双鸭山市",
                            "filename": "230000/230500"
                        },
                        {
                            "name": "大庆市",
                            "filename": "230000/230600"
                        },
                        {
                            "name": "伊春市",
                            "filename": "230000/230700"
                        },
                        {
                            "name": "佳木斯市",
                            "filename": "230000/230800"
                        },
                        {
                            "name": "七台河市",
                            "filename": "230000/230900"
                        },
                        {
                            "name": "牡丹江市",
                            "filename": "230000/231000"
                        },
                        {
                            "name": "黑河市",
                            "filename": "230000/231100"
                        },
                        {
                            "name": "绥化市",
                            "filename": "230000/231200"
                        },
                        {
                            "name": "大兴安岭地区",
                            "filename": "230000/232700"
                        }
                    ]
                },
                {
                    "name": "上海市",
                    "filename": "310000"
                },
                {
                    "name": "江苏省",
                    "filename": "320000",
                    "children": [
                        {
                            "name": "南京市",
                            "filename": "320000/320100"
                        },
                        {
                            "name": "无锡市",
                            "filename": "320000/320200"
                        },
                        {
                            "name": "徐州市",
                            "filename": "320000/320300"
                        },
                        {
                            "name": "常州市",
                            "filename": "320000/320400"
                        },
                        {
                            "name": "苏州市",
                            "filename": "320000/320500"
                        },
                        {
                            "name": "南通市",
                            "filename": "320000/320600"
                        },
                        {
                            "name": "连云港市",
                            "filename": "320000/320700"
                        },
                        {
                            "name": "淮安市",
                            "filename": "320000/320800"
                        },
                        {
                            "name": "盐城市",
                            "filename": "320000/320900"
                        },
                        {
                            "name": "扬州市",
                            "filename": "320000/321000"
                        },
                        {
                            "name": "镇江市",
                            "filename": "320000/321100"
                        },
                        {
                            "name": "泰州市",
                            "filename": "320000/321200"
                        },
                        {
                            "name": "宿迁市",
                            "filename": "320000/321300"
                        }
                    ]
                },
                {
                    "name": "浙江省",
                    "filename": "330000",
                    "children": [
                        {
                            "name": "杭州市",
                            "filename": "330000/330100"
                        },
                        {
                            "name": "宁波市",
                            "filename": "330000/330200"
                        },
                        {
                            "name": "温州市",
                            "filename": "330000/330300"
                        },
                        {
                            "name": "嘉兴市",
                            "filename": "330000/330400"
                        },
                        {
                            "name": "湖州市",
                            "filename": "330000/330500"
                        },
                        {
                            "name": "绍兴市",
                            "filename": "330000/330600"
                        },
                        {
                            "name": "金华市",
                            "filename": "330000/330700"
                        },
                        {
                            "name": "衢州市",
                            "filename": "330000/330800"
                        },
                        {
                            "name": "舟山市",
                            "filename": "330000/330900"
                        },
                        {
                            "name": "台州市",
                            "filename": "330000/331000"
                        },
                        {
                            "name": "丽水市",
                            "filename": "330000/331100"
                        }
                    ]
                },
                {
                    "name": "安徽省",
                    "filename": "340000",
                    "children": [
                        {
                            "name": "合肥市",
                            "filename": "340000/340100"
                        },
                        {
                            "name": "芜湖市",
                            "filename": "340000/340200"
                        },
                        {
                            "name": "蚌埠市",
                            "filename": "340000/340300"
                        },
                        {
                            "name": "淮南市",
                            "filename": "340000/340400"
                        },
                        {
                            "name": "马鞍山市",
                            "filename": "340000/340500"
                        },
                        {
                            "name": "淮北市",
                            "filename": "340000/340600"
                        },
                        {
                            "name": "铜陵市",
                            "filename": "340000/340700"
                        },
                        {
                            "name": "安庆市",
                            "filename": "340000/340800"
                        },
                        {
                            "name": "黄山市",
                            "filename": "340000/341000"
                        },
                        {
                            "name": "滁州市",
                            "filename": "340000/341100"
                        },
                        {
                            "name": "阜阳市",
                            "filename": "340000/341200"
                        },
                        {
                            "name": "宿州市",
                            "filename": "340000/341300"
                        },
                        {
                            "name": "六安市",
                            "filename": "340000/341500"
                        },
                        {
                            "name": "亳州市",
                            "filename": "340000/341600"
                        },
                        {
                            "name": "池州市",
                            "filename": "340000/341700"
                        },
                        {
                            "name": "宣城市",
                            "filename": "340000/341800"
                        }
                    ]
                },
                {
                    "name": "福建省",
                    "filename": "350000",
                    "children": [
                        {
                            "name": "福州市",
                            "filename": "350000/350100"
                        },
                        {
                            "name": "厦门市",
                            "filename": "350000/350200"
                        },
                        {
                            "name": "莆田市",
                            "filename": "350000/350300"
                        },
                        {
                            "name": "三明市",
                            "filename": "350000/350400"
                        },
                        {
                            "name": "泉州市",
                            "filename": "350000/350500"
                        },
                        {
                            "name": "漳州市",
                            "filename": "350000/350600"
                        },
                        {
                            "name": "南平市",
                            "filename": "350000/350700"
                        },
                        {
                            "name": "龙岩市",
                            "filename": "350000/350800"
                        },
                        {
                            "name": "宁德市",
                            "filename": "350000/350900"
                        }
                    ]
                },
                {
                    "name": "江西省",
                    "filename": "360000",
                    "children": [
                        {
                            "name": "南昌市",
                            "filename": "360000/360100"
                        },
                        {
                            "name": "景德镇市",
                            "filename": "360000/360200"
                        },
                        {
                            "name": "萍乡市",
                            "filename": "360000/360300"
                        },
                        {
                            "name": "九江市",
                            "filename": "360000/360400"
                        },
                        {
                            "name": "新余市",
                            "filename": "360000/360500"
                        },
                        {
                            "name": "鹰潭市",
                            "filename": "360000/360600"
                        },
                        {
                            "name": "赣州市",
                            "filename": "360000/360700"
                        },
                        {
                            "name": "吉安市",
                            "filename": "360000/360800"
                        },
                        {
                            "name": "宜春市",
                            "filename": "360000/360900"
                        },
                        {
                            "name": "抚州市",
                            "filename": "360000/361000"
                        },
                        {
                            "name": "上饶市",
                            "filename": "360000/361100"
                        }
                    ]
                },
                {
                    "name": "山东省",
                    "filename": "370000",
                    "children": [
                        {
                            "name": "济南市",
                            "filename": "370000/370100"
                        },
                        {
                            "name": "青岛市",
                            "filename": "370000/370200"
                        },
                        {
                            "name": "淄博市",
                            "filename": "370000/370300"
                        },
                        {
                            "name": "枣庄市",
                            "filename": "370000/370400"
                        },
                        {
                            "name": "东营市",
                            "filename": "370000/370500"
                        },
                        {
                            "name": "烟台市",
                            "filename": "370000/370600"
                        },
                        {
                            "name": "潍坊市",
                            "filename": "370000/370700"
                        },
                        {
                            "name": "济宁市",
                            "filename": "370000/370800"
                        },
                        {
                            "name": "泰安市",
                            "filename": "370000/370900"
                        },
                        {
                            "name": "威海市",
                            "filename": "370000/371000"
                        },
                        {
                            "name": "日照市",
                            "filename": "370000/371100"
                        },
                        {
                            "name": "临沂市",
                            "filename": "370000/371300"
                        },
                        {
                            "name": "德州市",
                            "filename": "370000/371400"
                        },
                        {
                            "name": "聊城市",
                            "filename": "370000/371500"
                        },
                        {
                            "name": "滨州市",
                            "filename": "370000/371600"
                        },
                        {
                            "name": "菏泽市",
                            "filename": "370000/371700"
                        }
                    ]
                },
                {
                    "name": "河南省",
                    "filename": "410000",
                    "children": [
                        {
                            "name": "郑州市",
                            "filename": "410000/410100"
                        },
                        {
                            "name": "开封市",
                            "filename": "410000/410200"
                        },
                        {
                            "name": "洛阳市",
                            "filename": "410000/410300"
                        },
                        {
                            "name": "平顶山市",
                            "filename": "410000/410400"
                        },
                        {
                            "name": "安阳市",
                            "filename": "410000/410500"
                        },
                        {
                            "name": "鹤壁市",
                            "filename": "410000/410600"
                        },
                        {
                            "name": "新乡市",
                            "filename": "410000/410700"
                        },
                        {
                            "name": "焦作市",
                            "filename": "410000/410800"
                        },
                        {
                            "name": "濮阳市",
                            "filename": "410000/410900"
                        },
                        {
                            "name": "许昌市",
                            "filename": "410000/411000"
                        },
                        {
                            "name": "漯河市",
                            "filename": "410000/411100"
                        },
                        {
                            "name": "三门峡市",
                            "filename": "410000/411200"
                        },
                        {
                            "name": "南阳市",
                            "filename": "410000/411300"
                        },
                        {
                            "name": "商丘市",
                            "filename": "410000/411400"
                        },
                        {
                            "name": "信阳市",
                            "filename": "410000/411500"
                        },
                        {
                            "name": "周口市",
                            "filename": "410000/411600"
                        },
                        {
                            "name": "驻马店市",
                            "filename": "410000/411700"
                        }
                    ]
                },
                {
                    "name": "湖北省",
                    "filename": "420000",
                    "children": [
                        {
                            "name": "武汉市",
                            "filename": "420000/420100"
                        },
                        {
                            "name": "黄石市",
                            "filename": "420000/420200"
                        },
                        {
                            "name": "十堰市",
                            "filename": "420000/420300"
                        },
                        {
                            "name": "宜昌市",
                            "filename": "420000/420500"
                        },
                        {
                            "name": "襄阳市",
                            "filename": "420000/420600"
                        },
                        {
                            "name": "鄂州市",
                            "filename": "420000/420700"
                        },
                        {
                            "name": "荆门市",
                            "filename": "420000/420800"
                        },
                        {
                            "name": "孝感市",
                            "filename": "420000/420900"
                        },
                        {
                            "name": "荆州市",
                            "filename": "420000/421000"
                        },
                        {
                            "name": "黄冈市",
                            "filename": "420000/421100"
                        },
                        {
                            "name": "咸宁市",
                            "filename": "420000/421200"
                        },
                        {
                            "name": "随州市",
                            "filename": "420000/421300"
                        },
                        {
                            "name": "恩施土家族苗族自治州",
                            "filename": "420000/422800"
                        }
                    ]
                },
                {
                    "name": "湖南省",
                    "filename": "430000",
                    "children": [
                        {
                            "name": "长沙市",
                            "filename": "430000/430100"
                        },
                        {
                            "name": "株洲市",
                            "filename": "430000/430200"
                        },
                        {
                            "name": "湘潭市",
                            "filename": "430000/430300"
                        },
                        {
                            "name": "衡阳市",
                            "filename": "430000/430400"
                        },
                        {
                            "name": "邵阳市",
                            "filename": "430000/430500"
                        },
                        {
                            "name": "岳阳市",
                            "filename": "430000/430600"
                        },
                        {
                            "name": "常德市",
                            "filename": "430000/430700"
                        },
                        {
                            "name": "张家界市",
                            "filename": "430000/430800"
                        },
                        {
                            "name": "益阳市",
                            "filename": "430000/430900"
                        },
                        {
                            "name": "郴州市",
                            "filename": "430000/431000"
                        },
                        {
                            "name": "永州市",
                            "filename": "430000/431100"
                        },
                        {
                            "name": "怀化市",
                            "filename": "430000/431200"
                        },
                        {
                            "name": "娄底市",
                            "filename": "430000/431300"
                        },
                        {
                            "name": "湘西土家族苗族自治州",
                            "filename": "430000/433100"
                        }
                    ]
                },
                {
                    "name": "广东省",
                    "filename": "440000",
                    "children": [
                        {
                            "name": "广州市",
                            "filename": "440000/440100"
                        },
                        {
                            "name": "韶关市",
                            "filename": "440000/440200"
                        },
                        {
                            "name": "深圳市",
                            "filename": "440000/440300"
                        },
                        {
                            "name": "珠海市",
                            "filename": "440000/440400"
                        },
                        {
                            "name": "汕头市",
                            "filename": "440000/440500"
                        },
                        {
                            "name": "佛山市",
                            "filename": "440000/440600"
                        },
                        {
                            "name": "江门市",
                            "filename": "440000/440700"
                        },
                        {
                            "name": "湛江市",
                            "filename": "440000/440800"
                        },
                        {
                            "name": "茂名市",
                            "filename": "440000/440900"
                        },
                        {
                            "name": "肇庆市",
                            "filename": "440000/441200"
                        },
                        {
                            "name": "惠州市",
                            "filename": "440000/441300"
                        },
                        {
                            "name": "梅州市",
                            "filename": "440000/441400"
                        },
                        {
                            "name": "汕尾市",
                            "filename": "440000/441500"
                        },
                        {
                            "name": "河源市",
                            "filename": "440000/441600"
                        },
                        {
                            "name": "阳江市",
                            "filename": "440000/441700"
                        },
                        {
                            "name": "清远市",
                            "filename": "440000/441800"
                        },
                        {
                            "name": "潮州市",
                            "filename": "440000/445100"
                        },
                        {
                            "name": "揭阳市",
                            "filename": "440000/445200"
                        },
                        {
                            "name": "云浮市",
                            "filename": "440000/445300"
                        }
                    ]
                },
                {
                    "name": "广西壮族自治区",
                    "filename": "450000",
                    "children": [
                        {
                            "name": "南宁市",
                            "filename": "450000/450100"
                        },
                        {
                            "name": "柳州市",
                            "filename": "450000/450200"
                        },
                        {
                            "name": "桂林市",
                            "filename": "450000/450300"
                        },
                        {
                            "name": "梧州市",
                            "filename": "450000/450400"
                        },
                        {
                            "name": "北海市",
                            "filename": "450000/450500"
                        },
                        {
                            "name": "防城港市",
                            "filename": "450000/450600"
                        },
                        {
                            "name": "钦州市",
                            "filename": "450000/450700"
                        },
                        {
                            "name": "贵港市",
                            "filename": "450000/450800"
                        },
                        {
                            "name": "玉林市",
                            "filename": "450000/450900"
                        },
                        {
                            "name": "百色市",
                            "filename": "450000/451000"
                        },
                        {
                            "name": "贺州市",
                            "filename": "450000/451100"
                        },
                        {
                            "name": "河池市",
                            "filename": "450000/451200"
                        },
                        {
                            "name": "来宾市",
                            "filename": "450000/451300"
                        },
                        {
                            "name": "崇左市",
                            "filename": "450000/451400"
                        }
                    ]
                },
                {
                    "name": "海南省",
                    "filename": "460000",
                    "children": [
                        {
                            "name": "海口市",
                            "filename": "460000/460100"
                        },
                        {
                            "name": "三亚市",
                            "filename": "460000/460200"
                        },
                        {
                            "name": "三沙市",
                            "filename": "460000/460300"
                        }
                    ]
                },
                {
                    "name": "重庆市",
                    "filename": "500000"
                },
                {
                    "name": "四川省",
                    "filename": "510000",
                    "children": [
                        {
                            "name": "成都市",
                            "filename": "510000/510100"
                        },
                        {
                            "name": "自贡市",
                            "filename": "510000/510300"
                        },
                        {
                            "name": "攀枝花市",
                            "filename": "510000/510400"
                        },
                        {
                            "name": "泸州市",
                            "filename": "510000/510500"
                        },
                        {
                            "name": "德阳市",
                            "filename": "510000/510600"
                        },
                        {
                            "name": "绵阳市",
                            "filename": "510000/510700"
                        },
                        {
                            "name": "广元市",
                            "filename": "510000/510800"
                        },
                        {
                            "name": "遂宁市",
                            "filename": "510000/510900"
                        },
                        {
                            "name": "内江市",
                            "filename": "510000/511000"
                        },
                        {
                            "name": "乐山市",
                            "filename": "510000/511100"
                        },
                        {
                            "name": "南充市",
                            "filename": "510000/511300"
                        },
                        {
                            "name": "眉山市",
                            "filename": "510000/511400"
                        },
                        {
                            "name": "宜宾市",
                            "filename": "510000/511500"
                        },
                        {
                            "name": "广安市",
                            "filename": "510000/511600"
                        },
                        {
                            "name": "达州市",
                            "filename": "510000/511700"
                        },
                        {
                            "name": "雅安市",
                            "filename": "510000/511800"
                        },
                        {
                            "name": "巴中市",
                            "filename": "510000/511900"
                        },
                        {
                            "name": "资阳市",
                            "filename": "510000/512000"
                        },
                        {
                            "name": "阿坝藏族羌族自治州",
                            "filename": "510000/513200"
                        },
                        {
                            "name": "甘孜藏族自治州",
                            "filename": "510000/513300"
                        },
                        {
                            "name": "凉山彝族自治州",
                            "filename": "510000/513400"
                        }
                    ]
                },
                {
                    "name": "贵州省",
                    "filename": "520000",
                    "children": [
                        {
                            "name": "贵阳市",
                            "filename": "520000/520100"
                        },
                        {
                            "name": "六盘水市",
                            "filename": "520000/520200"
                        },
                        {
                            "name": "遵义市",
                            "filename": "520000/520300"
                        },
                        {
                            "name": "安顺市",
                            "filename": "520000/520400"
                        },
                        {
                            "name": "毕节市",
                            "filename": "520000/520500"
                        },
                        {
                            "name": "铜仁市",
                            "filename": "520000/520600"
                        },
                        {
                            "name": "黔西南布依族苗族自治州",
                            "filename": "520000/522300"
                        },
                        {
                            "name": "黔东南苗族侗族自治州",
                            "filename": "520000/522600"
                        },
                        {
                            "name": "黔南布依族苗族自治州",
                            "filename": "520000/522700"
                        }
                    ]
                },
                {
                    "name": "云南省",
                    "filename": "530000",
                    "children": [
                        {
                            "name": "昆明市",
                            "filename": "530000/530100"
                        },
                        {
                            "name": "曲靖市",
                            "filename": "530000/530300"
                        },
                        {
                            "name": "玉溪市",
                            "filename": "530000/530400"
                        },
                        {
                            "name": "保山市",
                            "filename": "530000/530500"
                        },
                        {
                            "name": "昭通市",
                            "filename": "530000/530600"
                        },
                        {
                            "name": "丽江市",
                            "filename": "530000/530700"
                        },
                        {
                            "name": "普洱市",
                            "filename": "530000/530800"
                        },
                        {
                            "name": "临沧市",
                            "filename": "530000/530900"
                        },
                        {
                            "name": "楚雄彝族自治州",
                            "filename": "530000/532300"
                        },
                        {
                            "name": "红河哈尼族彝族自治州",
                            "filename": "530000/532500"
                        },
                        {
                            "name": "文山壮族苗族自治州",
                            "filename": "530000/532600"
                        },
                        {
                            "name": "西双版纳傣族自治州",
                            "filename": "530000/532800"
                        },
                        {
                            "name": "大理白族自治州",
                            "filename": "530000/532900"
                        },
                        {
                            "name": "德宏傣族景颇族自治州",
                            "filename": "530000/533100"
                        },
                        {
                            "name": "怒江傈僳族自治州",
                            "filename": "530000/533300"
                        },
                        {
                            "name": "迪庆藏族自治州",
                            "filename": "530000/533400"
                        }
                    ]
                },
                {
                    "name": "西藏自治区",
                    "filename": "540000",
                    "children": [
                        {
                            "name": "拉萨市",
                            "filename": "540000/540100"
                        },
                        {
                            "name": "日喀则市",
                            "filename": "540000/540200"
                        },
                        {
                            "name": "昌都市",
                            "filename": "540000/540300"
                        },
                        {
                            "name": "林芝市",
                            "filename": "540000/540400"
                        },
                        {
                            "name": "山南市",
                            "filename": "540000/540500"
                        },
                        {
                            "name": "那曲市",
                            "filename": "540000/540600"
                        },
                        {
                            "name": "阿里地区",
                            "filename": "540000/542500"
                        }
                    ]
                },
                {
                    "name": "陕西省",
                    "filename": "610000",
                    "children": [
                        {
                            "name": "西安市",
                            "filename": "610000/610100"
                        },
                        {
                            "name": "铜川市",
                            "filename": "610000/610200"
                        },
                        {
                            "name": "宝鸡市",
                            "filename": "610000/610300"
                        },
                        {
                            "name": "咸阳市",
                            "filename": "610000/610400"
                        },
                        {
                            "name": "渭南市",
                            "filename": "610000/610500"
                        },
                        {
                            "name": "延安市",
                            "filename": "610000/610600"
                        },
                        {
                            "name": "汉中市",
                            "filename": "610000/610700"
                        },
                        {
                            "name": "榆林市",
                            "filename": "610000/610800"
                        },
                        {
                            "name": "安康市",
                            "filename": "610000/610900"
                        },
                        {
                            "name": "商洛市",
                            "filename": "610000/611000"
                        }
                    ]
                },
                {
                    "name": "甘肃省",
                    "filename": "620000",
                    "children": [
                        {
                            "name": "兰州市",
                            "filename": "620000/620100"
                        },
                        {
                            "name": "金昌市",
                            "filename": "620000/620300"
                        },
                        {
                            "name": "白银市",
                            "filename": "620000/620400"
                        },
                        {
                            "name": "天水市",
                            "filename": "620000/620500"
                        },
                        {
                            "name": "武威市",
                            "filename": "620000/620600"
                        },
                        {
                            "name": "张掖市",
                            "filename": "620000/620700"
                        },
                        {
                            "name": "平凉市",
                            "filename": "620000/620800"
                        },
                        {
                            "name": "酒泉市",
                            "filename": "620000/620900"
                        },
                        {
                            "name": "庆阳市",
                            "filename": "620000/621000"
                        },
                        {
                            "name": "定西市",
                            "filename": "620000/621100"
                        },
                        {
                            "name": "陇南市",
                            "filename": "620000/621200"
                        },
                        {
                            "name": "临夏回族自治州",
                            "filename": "620000/622900"
                        },
                        {
                            "name": "甘南藏族自治州",
                            "filename": "620000/623000"
                        }
                    ]
                },
                {
                    "name": "青海省",
                    "filename": "630000",
                    "children": [
                        {
                            "name": "西宁市",
                            "filename": "630000/630100"
                        },
                        {
                            "name": "海东市",
                            "filename": "630000/630200"
                        },
                        {
                            "name": "海北藏族自治州",
                            "filename": "630000/632200"
                        },
                        {
                            "name": "黄南藏族自治州",
                            "filename": "630000/632300"
                        },
                        {
                            "name": "海南藏族自治州",
                            "filename": "630000/632500"
                        },
                        {
                            "name": "果洛藏族自治州",
                            "filename": "630000/632600"
                        },
                        {
                            "name": "玉树藏族自治州",
                            "filename": "630000/632700"
                        },
                        {
                            "name": "海西蒙古族藏族自治州",
                            "filename": "630000/632800"
                        }
                    ]
                },
                {
                    "name": "宁夏回族自治区",
                    "filename": "640000",
                    "children": [
                        {
                            "name": "银川市",
                            "filename": "640000/640100"
                        },
                        {
                            "name": "石嘴山市",
                            "filename": "640000/640200"
                        },
                        {
                            "name": "吴忠市",
                            "filename": "640000/640300"
                        },
                        {
                            "name": "固原市",
                            "filename": "640000/640400"
                        },
                        {
                            "name": "中卫市",
                            "filename": "640000/640500"
                        }
                    ]
                },
                {
                    "name": "新疆维吾尔自治区",
                    "filename": "650000",
                    "children": [
                        {
                            "name": "乌鲁木齐市",
                            "filename": "650000/650100"
                        },
                        {
                            "name": "克拉玛依市",
                            "filename": "650000/650200"
                        },
                        {
                            "name": "吐鲁番市",
                            "filename": "650000/650400"
                        },
                        {
                            "name": "哈密市",
                            "filename": "650000/650500"
                        },
                        {
                            "name": "昌吉回族自治州",
                            "filename": "650000/652300"
                        },
                        {
                            "name": "博尔塔拉蒙古自治州",
                            "filename": "650000/652700"
                        },
                        {
                            "name": "巴音郭楞蒙古自治州",
                            "filename": "650000/652800"
                        },
                        {
                            "name": "阿克苏地区",
                            "filename": "650000/652900"
                        },
                        {
                            "name": "克孜勒苏柯尔克孜自治州",
                            "filename": "650000/653000"
                        },
                        {
                            "name": "喀什地区",
                            "filename": "650000/653100"
                        },
                        {
                            "name": "和田地区",
                            "filename": "650000/653200"
                        },
                        {
                            "name": "伊犁哈萨克自治州",
                            "filename": "650000/654000"
                        },
                        {
                            "name": "塔城地区",
                            "filename": "650000/654200"
                        },
                        {
                            "name": "阿勒泰地区",
                            "filename": "650000/654300"
                        }
                    ]
                },
                {
                    "name": "台湾省",
                    "filename": "710000",
                    "children": [
                        {
                            "name": "台北市",
                            "filename": "710000/711000"
                        },
                        {
                            "name": "台中市",
                            "filename": "710000/711100"
                        },
                        {
                            "name": "基隆市",
                            "filename": "710000/711200"
                        },
                        {
                            "name": "台南市",
                            "filename": "710000/711300"
                        },
                        {
                            "name": "高雄市",
                            "filename": "710000/711400"
                        },
                        {
                            "name": "新北市",
                            "filename": "710000/711500"
                        },
                        {
                            "name": "宜兰县",
                            "filename": "710000/711600"
                        },
                        {
                            "name": "桃园市",
                            "filename": "710000/711700"
                        },
                        {
                            "name": "嘉义市",
                            "filename": "710000/711800"
                        },
                        {
                            "name": "新竹县",
                            "filename": "710000/711900"
                        },
                        {
                            "name": "苗栗县",
                            "filename": "710000/712000"
                        },
                        {
                            "name": "南投县",
                            "filename": "710000/712200"
                        },
                        {
                            "name": "彰化县",
                            "filename": "710000/712300"
                        },
                        {
                            "name": "新竹市",
                            "filename": "710000/712400"
                        },
                        {
                            "name": "云林县",
                            "filename": "710000/712500"
                        },
                        {
                            "name": "嘉义县",
                            "filename": "710000/712600"
                        },
                        {
                            "name": "屏东县",
                            "filename": "710000/712900"
                        },
                        {
                            "name": "花莲县",
                            "filename": "710000/713000"
                        },
                        {
                            "name": "台东县",
                            "filename": "710000/713100"
                        },
                        {
                            "name": "澎湖县",
                            "filename": "710000/713200"
                        }
                    ]
                },
                {
                    "name": "香港特别行政区",
                    "filename": "810000"
                },
                {
                    "name": "澳门特别行政区",
                    "filename": "820000"
                }
            ]
        }
    ]
}